import {Component, inject, Input, OnInit} from '@angular/core';
import {IconButtonComponent} from '../../../../shared/components/icon-button/icon-button.component';
import {AppointmentSelectionService} from '../../appointment-selection.service';
import {DatePipe, Location} from '@angular/common';
import {DateTime} from 'luxon';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {Router} from '@angular/router';
import {CustomDatePipe} from '../../../../shared/pipes/custom-date-pipe';

type DayState = 'hidden' | 'unavailable' | 'available' | 'today-unavailable' | 'today-available' | 'selected';

@Component({
  selector: 'app-date-selection',
  imports: [
    IconButtonComponent,
    TranslocoPipe,
    CustomDatePipe
  ],
  templateUrl: './date-selection.component.html',
  styleUrl: './date-selection.component.scss'
})
export class DateSelectionComponent implements OnInit {
  @Input() mobile = true;

  location: Location = inject(Location);
  appointmentSelectionService: AppointmentSelectionService = inject(AppointmentSelectionService);
  translocoService: TranslocoService = inject(TranslocoService);
  router: Router = inject(Router);

  today: DateTime = DateTime.now().startOf('day');
  dayList!: DateTime[];

  weekdays: string[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

  ngOnInit() {
    if (!this.appointmentSelectionService.timeSlotDtosMap || this.appointmentSelectionService.timeSlotDtosMap.size === 0) {
      this.router.navigate(['/appointment-selection']);
    }

    this.setDayList();
  }

  changeMonth(delta: number) {
    const newMonth = this.appointmentSelectionService.monthForm.value?.plus({months: delta});

    if (newMonth) {
      this.appointmentSelectionService.monthForm.setValue(newMonth);
      this.setDayList();
    }
  }

  setDayList(): void {
    let result: DateTime[] = [];

    const firstDay = this.appointmentSelectionService.monthForm.value?.startOf('week');
    for (let i = 0; i < 7 * 6; i++) {
      const day = firstDay?.plus({days: i});
      if (day) {
        result.push(day);
      } else {
        result.push(DateTime.fromISO('2000-01-01'));
      }
    }

    this.dayList = result;
  }

  getDayState(day: DateTime): DayState {
    if (!day.startOf('month').equals(this.appointmentSelectionService.monthForm.value!)) {
      return 'hidden';
    }

    const isToday = day.startOf('day').equals(this.today);

    const isoDate = day.toISODate();
    if (!isoDate) {
      return 'hidden';
    }

    const timeSlotDtos = this.appointmentSelectionService.timeSlotDtosMap?.get(isoDate);
    if (timeSlotDtos && timeSlotDtos.length > 0) {
      if (this.appointmentSelectionService.dateForm?.value && day.equals(this.appointmentSelectionService.dateForm?.value)) {
        return 'selected';
      }

      return isToday ? 'today-available' : 'available';
    }

    return isToday ? 'today-unavailable' : 'unavailable';
  }

  selectDay(day: DateTime) {
    const isoDate = day.toISODate();
    if (!isoDate) {
      return;
    }

    this.appointmentSelectionService.dateForm?.setValue(day);
    if (this.mobile) {
      this.router.navigate(['/appointment-selection/time-selection']);
    }
  }

  back() {
    this.location.back();
  }
}
